import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Teleport as _Teleport, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ng-extend-logo" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-symbols-outlined",
  style: {"font-size":"16px","vertical-align":"middle"}
}, "forum", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "nge-ask-label" }, "AI", -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 0,
  class: "nge-dataset-species"
}
const _hoisted_9 = {
  key: 1,
  class: "material-symbols-outlined",
  style: {"font-size":"16px","vertical-align":"middle"}
}
const _hoisted_10 = { class: "nge-dataset-label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  id: "insertNGTopBar",
  class: "flex-fill"
}, null, -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "nge-share-toast"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "nge-share-toast-icon" }, [
  /*#__PURE__*/_createCommentVNode(" Back neuron (offset up-left) "),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-share-neuron nge-share-neuron--back",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("filter", {
        id: "shareNeuronGlow",
        x: "-40%",
        y: "-40%",
        width: "180%",
        height: "180%"
      }, [
        /*#__PURE__*/_createElementVNode("feGaussianBlur", {
          in: "SourceGraphic",
          stdDeviation: "0.7",
          result: "b1"
        }),
        /*#__PURE__*/_createElementVNode("feGaussianBlur", {
          in: "SourceGraphic",
          stdDeviation: "2",
          result: "b2"
        }),
        /*#__PURE__*/_createElementVNode("feMerge", null, [
          /*#__PURE__*/_createElementVNode("feMergeNode", { in: "b2" }),
          /*#__PURE__*/_createElementVNode("feMergeNode", { in: "b1" }),
          /*#__PURE__*/_createElementVNode("feMergeNode", { in: "SourceGraphic" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("radialGradient", {
        id: "shareSomaGrad",
        cx: "50%",
        cy: "50%",
        r: "50%"
      }, [
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#80f0ff",
          "stop-opacity": "1"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "60%",
          "stop-color": "#20d0ff",
          "stop-opacity": "0.8"
        }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#00a0e0",
          "stop-opacity": "0.2"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("g", { filter: "url(#shareNeuronGlow)" }, [
      /*#__PURE__*/_createCommentVNode(" Apical trunk + tuft "),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 30 L29 22 L27 14 L24 6",
        stroke: "#18cfff",
        "stroke-width": "1.6",
        "stroke-linecap": "round",
        opacity: "0.85"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L33 10 L40 7",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.7"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L21 10 L14 8",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.7"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L20 2",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L28 2",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createCommentVNode(" Basal dendrites "),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L24 38 L18 44",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L36 38 L42 44",
        stroke: "#15c8f8",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L30 42 L30 52",
        stroke: "#10b8e8",
        "stroke-width": "0.9",
        "stroke-linecap": "round",
        opacity: "0.55"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M18 44 L14 50",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.4"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M42 44 L46 50",
        stroke: "#0ab0e0",
        "stroke-width": "0.6",
        "stroke-linecap": "round",
        opacity: "0.4"
      }),
      /*#__PURE__*/_createCommentVNode(" Soma "),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "30",
        cy: "30",
        r: "4",
        fill: "url(#shareSomaGrad)"
      })
    ])
  ]),
  /*#__PURE__*/_createCommentVNode(" Front neuron (offset down-right, brighter) "),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-share-neuron nge-share-neuron--front",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { filter: "url(#shareNeuronGlow)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 30 L29 22 L27 14 L24 6",
        stroke: "#5be3ff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        opacity: "1"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L33 10 L40 7",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.85"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M27 14 L21 10 L14 8",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.85"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L20 2",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M24 6 L28 2",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.65"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L24 38 L18 44",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.8"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L36 38 L42 44",
        stroke: "#4dd8f8",
        "stroke-width": "1.1",
        "stroke-linecap": "round",
        opacity: "0.8"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M30 32 L30 42 L30 52",
        stroke: "#3acaee",
        "stroke-width": "1.0",
        "stroke-linecap": "round",
        opacity: "0.7"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M18 44 L14 50",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M42 44 L46 50",
        stroke: "#3acaee",
        "stroke-width": "0.7",
        "stroke-linecap": "round",
        opacity: "0.5"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "30",
        cy: "30",
        r: "4.5",
        fill: "url(#shareSomaGrad)"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "nge-share-toast-text" }, "Link copied to clipboard", -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 8h3l2-2.5h8L18 8h3v11H3z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13.5",
    r: "3.8"
  })
], -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 8V5h3M17 5h3v3M20 16v3h-3M7 19H4v-3" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8.5 12a3.5 3.5 0 1 0 1-2.45" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8.5 8.2v1.6h1.6" })
], -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3.5 6.5l8.5 6.5 8.5-6.5" })
], -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17.5 3h3.2l-7 8 8.2 10h-6.4l-5-6.5L4.7 21H1.5l7.5-8.5L1.2 3h6.6l4.5 6zm-1.1 16.2h1.8L7.7 4.7H5.8z" })
], -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 7h3V4h-3c-1.93 0-3.5 1.57-3.5 3.5V10H8v3h2.5v8h3v-8H16l1-3h-3.5V7.5c0-.28.22-.5.5-.5z" })
], -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 3,
  class: "nge-toolbar-icons"
}
const _hoisted_26 = ["title"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-hunt-pill-gem",
  viewBox: "0 0 24 24",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 3h10l4 6-9 12L3 9z",
    fill: "currentColor",
    opacity: "0.9"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3 9h18M9 3l3 6 3-6M12 9v12",
    fill: "none",
    stroke: "rgba(8,13,26,0.55)",
    "stroke-width": "1.2"
  })
], -1 /* HOISTED */)
const _hoisted_28 = { class: "nge-hunt-pill-word" }
const _hoisted_29 = {
  key: 0,
  class: "nge-hunt-pill-time"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-hunt-pill-gem",
  viewBox: "0 0 24 24",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 3h10l4 6-9 12L3 9z",
    fill: "currentColor",
    opacity: "0.9"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3 9h18M9 3l3 6 3-6M12 9v12",
    fill: "none",
    stroke: "rgba(8,13,26,0.55)",
    "stroke-width": "1.2"
  })
], -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-pill-word" }, "Help build", -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<svg class=\"nge-bug\" width=\"19\" height=\"19\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#dfe6f2\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><g class=\"nge-bug-legs nge-bug-legs--l\"><path d=\"M8.2 11 L4.6 9\"></path><path d=\"M7.9 14.2 H3.9\"></path><path d=\"M8.2 17.2 L4.6 19.4\"></path></g><g class=\"nge-bug-legs nge-bug-legs--r\"><path d=\"M15.8 11 L19.4 9\"></path><path d=\"M16.1 14.2 H20.1\"></path><path d=\"M15.8 17.2 L19.4 19.4\"></path></g><path d=\"M10.4 6.2 L8.6 3.8 M13.6 6.2 L15.4 3.8\"></path><circle cx=\"12\" cy=\"7.9\" r=\"2.3\"></circle><rect x=\"8\" y=\"10.1\" width=\"8\" height=\"10.4\" rx=\"4\"></rect><path d=\"M12 10.8 V19.6\"></path></svg>", 1)
const _hoisted_34 = ["data-icon-id", "title", "aria-disabled", "onDragstart", "onDragover", "onDragleave", "onDrop", "onClick"]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["src"]
const _hoisted_37 = ["title"]
const _hoisted_38 = ["title"]
const _hoisted_39 = {
  key: 0,
  class: "nge-player-view-dot",
  "aria-label": "Admin notifications waiting"
}
const _hoisted_40 = {
  viewBox: "2.6 1.6 10.8 13.2",
  fill: "none",
  style: {"width":"1em","height":"1em","vertical-align":"middle","color":"#cfdcef"}
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "5.4",
  r: "2.9",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1 /* HOISTED */)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.4 14c0-2.7 2.1-4.6 4.6-4.6s4.6 1.9 4.6 4.6",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, null, -1 /* HOISTED */)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num nge-menu-num--icon" }, "🧭", -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "Site Tour", -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num" }, "1", -1 /* HOISTED */)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", null, "Get Started", -1 /* HOISTED */)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num" }, "2", -1 /* HOISTED */)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", null, "Merge", -1 /* HOISTED */)
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num" }, "3", -1 /* HOISTED */)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, "Cut", -1 /* HOISTED */)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num" }, "4", -1 /* HOISTED */)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", null, "Advanced Interface", -1 /* HOISTED */)
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num" }, "5", -1 /* HOISTED */)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "nge-menu-num" }
const _hoisted_64 = { class: "nge-menu-num" }
const _hoisted_65 = { class: "nge-menu-num" }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num nge-menu-num--icon" }, "🕹️", -1 /* HOISTED */)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", null, "Pyr Arcade", -1 /* HOISTED */)
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num nge-menu-num--icon" }, "📷", -1 /* HOISTED */)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", null, "Photo Mode", -1 /* HOISTED */)
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num nge-menu-num--icon" }, "💬", -1 /* HOISTED */)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", null, "Forum ↗", -1 /* HOISTED */)
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "nge-menu-num nge-menu-num--icon" }, "⌨️", -1 /* HOISTED */)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", null, "Keyboard shortcuts", -1 /* HOISTED */)
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { id: "ngFarRight" }, null, -1 /* HOISTED */)
const _hoisted_80 = {
  key: 0,
  class: "nge-mobile-nav"
}
const _hoisted_81 = { class: "nge-mnav-icon" }
const _hoisted_82 = ["src"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Cells", -1 /* HOISTED */)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "💬", -1 /* HOISTED */)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Chat", -1 /* HOISTED */)
const _hoisted_86 = {
  key: 0,
  class: "nge-mnav-badge"
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "📍", -1 /* HOISTED */)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Tags", -1 /* HOISTED */)
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "🔔", -1 /* HOISTED */)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Notifs", -1 /* HOISTED */)
const _hoisted_92 = {
  key: 0,
  class: "nge-mnav-badge"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-icon" }, "✨", -1 /* HOISTED */)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "nge-mnav-label" }, "Guide", -1 /* HOISTED */)
const _hoisted_95 = [
  _hoisted_93,
  _hoisted_94
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_visible = _resolveDirective("visible")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["LoginModal"]),
    _createVNode($setup["LanternBar"]),
    _createCommentVNode(" <annotation-panel /> "),
    _createCommentVNode(" Hidden: users pick cells from Cell Library instead "),
    _createVNode($setup["AchievementToast"]),
    _createVNode($setup["StagingAnnouncement"]),
    _createCommentVNode(" Test sites only (util/toolbar_staging.ts). "),
    ($setup.STAGING_TEST_AVAILABLE)
      ? (_openBlock(), _createBlock($setup["StagingTestPanel"], { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["CommandPalette"], {
      ref: "cmdPalette",
      onOpenProfile: _cache[0] || (_cache[0] = $event => ($setup.showProfile = true)),
      onOpenRecap: _cache[1] || (_cache[1] = $event => ($setup.openWeekRecap())),
      onOpenLeaderboard: _cache[2] || (_cache[2] = $event => ($setup.showLeaderboard = true)),
      onOpenSettings: _cache[3] || (_cache[3] = $event => {$setup.profileInitialTab = 'settings'; $setup.showProfile = true}),
      onOpenHelp: _cache[4] || (_cache[4] = $event => {$setup.cellLibraryInitialTab = 'help'; $setup.showCellLibrary = true}),
      onOpenQueue: _cache[5] || (_cache[5] = $event => ($setup.showQueue = true)),
      onOpenCells: _cache[6] || (_cache[6] = $event => ($setup.showCellLibrary = true)),
      onOpenFeed: _cache[7] || (_cache[7] = $event => ($setup.showFeed = true)),
      onOpenDatasetSelector: _cache[8] || (_cache[8] = $event => ($setup.showDatasetSelector = true)),
      onOpenDatasetStats: _cache[9] || (_cache[9] = $event => ($setup.openDatasetStatsHome()))
    }, null, 512 /* NEED_PATCH */),
    ($setup.showFeed)
      ? (_openBlock(), _createBlock($setup["ActivityFeedPanel"], {
          key: 1,
          onHide: _cache[10] || (_cache[10] = $event => ($setup.showFeed = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showAccess)
      ? (_openBlock(), _createBlock($setup["AccessRequestPanel"], {
          key: 2,
          onHide: _cache[11] || (_cache[11] = $event => ($setup.showAccess = false))
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["AccessReviewBar"]),
    _createVNode($setup["HuntPlacesBox"]),
    ($setup.huntBackend.isAdmin)
      ? (_openBlock(), _createBlock($setup["HuntReportCard"], { key: 3 }))
      : _createCommentVNode("v-if", true),
    ($setup.huntBackend.isAdmin)
      ? (_openBlock(), _createBlock($setup["BuildQueueCard"], { key: 4 }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["HelpBuildBox"]),
    _createVNode($setup["TestReviewBar"]),
    _createVNode($setup["TestQueueCard"]),
    _createCommentVNode(" Help requests now live in Cell Library's Help tab "),
    ($setup.showQueue)
      ? (_openBlock(), _createBlock($setup["ProofreadingQueuePanel"], {
          key: 5,
          onHide: _cache[12] || (_cache[12] = $event => ($setup.showQueue = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showCellLibrary)
      ? (_openBlock(), _createBlock($setup["CellLibraryPanel"], {
          key: 6,
          "initial-tab": $setup.cellLibraryInitialTab,
          onHide: _cache[13] || (_cache[13] = $event => {$setup.showCellLibrary = false; $setup.cellLibraryInitialTab = undefined})
        }, null, 8 /* PROPS */, ["initial-tab"]))
      : _createCommentVNode("v-if", true),
    ($setup.showBatchProcessor)
      ? (_openBlock(), _createBlock($setup["BatchProcessorPanel"], {
          key: 7,
          onHide: _cache[14] || (_cache[14] = $event => ($setup.showBatchProcessor = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showTagMode)
      ? (_openBlock(), _createBlock($setup["TagModePanel"], {
          key: 8,
          onHide: _cache[15] || (_cache[15] = $event => ($setup.showTagMode = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showHighlight)
      ? (_openBlock(), _createBlock($setup["HighlightModePanel"], {
          key: 9,
          onHide: _cache[16] || (_cache[16] = $event => ($setup.showHighlight = false))
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Mentor mode and Team mode: shows only for an invitation or a live session. "),
    _createVNode($setup["TeamPanel"]),
    _createCommentVNode(" \"A newer version is out\": only when the game was updated since this page loaded. "),
    _createVNode($setup["VersionNotice"]),
    ($setup.showFlightMode)
      ? (_openBlock(), _createBlock($setup["FlightMode"], {
          key: 10,
          onHide: _cache[17] || (_cache[17] = $event => ($setup.showFlightMode = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showPhotoMode)
      ? (_openBlock(), _createBlock($setup["PhotoMode"], {
          key: 11,
          onHide: _cache[18] || (_cache[18] = $event => ($setup.showPhotoMode = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showArcade)
      ? (_openBlock(), _createBlock($setup["PyrArcade"], {
          key: 12,
          onHide: _cache[19] || (_cache[19] = $event => ($setup.showArcade = false))
        }))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createVNode($setup["VolumesOverlay"], {
      onHide: _cache[20] || (_cache[20] = $event => ($setup.showModal = false))
    }, null, 512 /* NEED_PATCH */), [
      [_directive_visible, $setup.showModal]
    ]),
    ($setup.showDatasetSelector)
      ? (_openBlock(), _createBlock($setup["DatasetSelectorPanel"], {
          key: 13,
          onHide: _cache[21] || (_cache[21] = $event => ($setup.showDatasetSelector = false))
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Invite only for now (Ames 2026-10-24): players not on Pilot testers. "),
    _createVNode($setup["BetaGate"]),
    _createVNode($setup["PrinciplesGate"]),
    ($setup.showProfile)
      ? (_openBlock(), _createBlock($setup["UserProfilePanel"], {
          key: 14,
          "view-user-id": $setup.profileUserId,
          "initial-tab": $setup.profileInitialTab,
          onHide: _cache[22] || (_cache[22] = $event => {$setup.showProfile = false; $setup.profileUserId = null; $setup.profileInitialTab = undefined}),
          onOpenSettings: _cache[23] || (_cache[23] = $event => {$setup.profileInitialTab = 'settings'; $setup.showProfile = true})
        }, null, 8 /* PROPS */, ["view-user-id", "initial-tab"]))
      : _createCommentVNode("v-if", true),
    ($setup.showFeedback)
      ? (_openBlock(), _createBlock($setup["FeedbackModal"], {
          key: 15,
          onHide: _cache[24] || (_cache[24] = $event => ($setup.showFeedback = false))
        }))
      : _createCommentVNode("v-if", true),
    ($setup.showNurroProfile)
      ? (_openBlock(), _createBlock($setup["NurroProfile"], {
          key: 16,
          onHide: _cache[25] || (_cache[25] = $event => ($setup.showNurroProfile = false))
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Always a peek on desktop (Ames 2026-09-30): no dim, the site stays usable, a click elsewhere puts it away. Phones keep the sheet. "),
    ($setup.showLeaderboard)
      ? (_openBlock(), _createBlock($setup["LeaderboardPanel"], {
          key: 17,
          peek: $setup.leaderboardPeek || !$setup.isMobileRef,
          onHide: _cache[26] || (_cache[26] = $event => {$setup.showLeaderboard = false; $setup.leaderboardPeek = false})
        }, null, 8 /* PROPS */, ["peek"]))
      : _createCommentVNode("v-if", true),
    ($setup.showDatasetStats)
      ? (_openBlock(), _createBlock($setup["DatasetStatsPanel"], {
          key: 18,
          peek: !$setup.isMobileRef,
          onHide: _cache[27] || (_cache[27] = $event => ($setup.showDatasetStats = false))
        }, null, 8 /* PROPS */, ["peek"]))
      : _createCommentVNode("v-if", true),
    ($setup.showSettings)
      ? (_openBlock(), _createBlock($setup["SettingsPanel"], {
          key: 19,
          onHide: _cache[28] || (_cache[28] = $event => ($setup.showSettings = false))
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Out of the way while the profile is open, as it was when the profile closes (Ames 2026-10-22:\n       \"the hunt box overlapping profile when I click achievement\") "),
    ($setup.showHunt)
      ? _withDirectives((_openBlock(), _createBlock($setup["HuntPanel"], {
          key: 20,
          "hunt-id": $setup.huntPanelId,
          test: $setup.huntPanelTest,
          onHide: _cache[29] || (_cache[29] = $event => {$setup.showHunt = false; $setup.huntPanelTest = false}),
          onPick: $setup.pickHunt
        }, null, 8 /* PROPS */, ["hunt-id", "test"])), [
          [_vShow, !$setup.showProfile]
        ])
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Each gem's answer on the spot; the start of a Hunt (Ames 2026-10-21) "),
    _createVNode($setup["HuntGemFx"]),
    _createVNode($setup["HuntBegins"], { onOpen: $setup.openHunt }),
    _createVNode($setup["HuntOpening"]),
    _createVNode($setup["NotificationFeedPanel"], {
      visible: $setup.showNotifications,
      onHide: _cache[30] || (_cache[30] = $event => ($setup.showNotifications = false)),
      onOpenHelp: _cache[31] || (_cache[31] = $event => {$setup.cellLibraryInitialTab = 'help'; $setup.showCellLibrary = true})
    }, null, 8 /* PROPS */, ["visible"]),
    ($setup.showChat)
      ? (_openBlock(), _createBlock($setup["ChatPanel"], {
          key: 21,
          onHide: _cache[32] || (_cache[32] = $event => ($setup.showChat = false))
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" The Ask dock is now the single command surface: it searches the same\n       catalog CommandPalette builds (passed in headless) so navigation runs\n       instantly, and only falls through to the model for real questions. "),
    _createCommentVNode(" Self-contained: listens for nge:prompt-username (fired after Tutorial 1)\n       and no-ops if the user already has a handle or dismissed it before. "),
    _createVNode($setup["UsernamePrompt"]),
    _createVNode($setup["AssistantDock"], {
      show: $setup.showAssistant,
      "ui-state": $setup.assistantUiState,
      "search-commands": $setup.searchCommands,
      "run-command-by-id": $setup.runCommandById,
      "list-keys": $setup.listKeys,
      onHide: _cache[33] || (_cache[33] = $event => ($setup.showAssistant = false))
    }, null, 8 /* PROPS */, ["show", "ui-state"]),
    _createElementVNode("div", {
      id: "extensionBar",
      onFocusin: $setup.onBarFocusIn,
      onFocusout: $setup.onBarFocusOut
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createCommentVNode(" Click → hard refresh. Reloads the bundle from the server (skips\n           the disk cache so a freshly-deployed JS hits the user without a\n           manual Ctrl+F5). Tour step #2 explains this. "),
        _createElementVNode("a", {
          href: "#",
          title: "EyeWire II — click to hard refresh",
          onClick: _withModifiers($setup.hardRefresh, ["prevent"])
        }, [
          _createElementVNode("img", {
            src: $setup.pyrIcon,
            class: "nge-pyr-logo"
          }, null, 8 /* PROPS */, _hoisted_3)
        ], 8 /* PROPS */, _hoisted_2)
      ]),
      _createCommentVNode(" AI guide + Dataset live on the left edge (Amy 2026-08-17). "),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-ask-btn", { 'nge-ask-btn--active': $setup.showAssistant }]),
        onClick: _cache[34] || (_cache[34] = $event => ($setup.showAssistant = !$setup.showAssistant)),
        title: "Nurro, your guide"
      }, _hoisted_6, 2 /* CLASS */),
      _createElementVNode("button", {
        class: "nge-dataset-btn",
        onClick: _cache[35] || (_cache[35] = $event => ($setup.showDatasetSelector = !$setup.showDatasetSelector)),
        title: 'Current dataset: ' + $setup.currentDatasetName + ' — click to switch'
      }, [
        ($setup.currentDatasetIcon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.currentDatasetIcon), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, "database")),
        _createElementVNode("span", _hoisted_10, _toDisplayString($setup.currentDatasetAbbrev), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_7),
      _hoisted_11,
      _createVNode(_Transition, { name: "nge-share-toast" }, {
        default: _withCtx(() => [
          ($setup.shareCopied)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("div", { class: "nge-share-toast-actions" }, [
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Save screenshot",
                    onClick: $setup.shareActionScreenshot
                  }, _hoisted_16),
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Photo mode: full screen 3D, spin, save a picture or a spin",
                    onClick: $setup.shareActionPhoto
                  }, _hoisted_18),
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Email link",
                    onClick: $setup.shareActionEmail
                  }, _hoisted_20),
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Post to X",
                    onClick: $setup.shareActionX
                  }, _hoisted_22),
                  _createElementVNode("button", {
                    class: "nge-share-action",
                    title: "Share to Facebook",
                    onClick: $setup.shareActionFacebook
                  }, _hoisted_24)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode($setup["ScreenshotDialog"], {
        show: $setup.showScreenshotDialog,
        onClose: _cache[36] || (_cache[36] = $event => ($setup.showScreenshotDialog = false))
      }, null, 8 /* PROPS */, ["show"]),
      ($setup.volumes.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[37] || (_cache[37] = $event => ($setup.showModal = true))
          }, "Volumes (" + _toDisplayString($setup.volumes.length) + ")", 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 🔥 streak: its fire, its click and its card live in StreakChip.vue "),
      _createCommentVNode(" EyeWire Radio: bottom right, teleported to the body. Not until the\n         player is past the beta gate: its screen covers the control. "),
      ($setup.login.sessions.length > 0 && $setup.betaGate === 'in' && !$setup.useUserPreferencesStore().prefs.hideRadio)
        ? (_openBlock(), _createBlock($setup["RadioPlayer"], { key: 1 }))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0 && $setup.stats.currentStreak > 0)
        ? (_openBlock(), _createBlock($setup["StreakChip"], {
            key: 2,
            current: $setup.stats.currentStreak,
            best: $setup.stats.longestStreak
          }, null, 8 /* PROPS */, ["current", "best"]))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createCommentVNode(" The Hunt: only while one is announced, running or just over. "),
            ($setup.huntPill)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["nge-hunt-pill", `nge-hunt-pill--${$setup.huntPill.phase}`]),
                  title: $setup.huntPill.phase === 'live' ? 'The Hunt is on: open it' : $setup.huntPill.phase === 'announced' ? 'A Hunt is coming' : 'The Hunt is over: see the winners',
                  onClick: _cache[38] || (_cache[38] = $event => ($setup.openHunt($setup.huntPill.id)))
                }, [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString($setup.huntPill.word), 1 /* TEXT */),
                  ($setup.huntPill.time)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clockParts($setup.huntPill.time), (p, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: i,
                            class: _normalizeClass({ 'nge-digit': p.d })
                          }, _toDisplayString(p.c), 3 /* TEXT, CLASS */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 10 /* CLASS, PROPS */, _hoisted_26))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Help build a Hunt: an invited helper's cells (hunt_build.ts). "),
            ($setup.buildState.mine.length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "nge-hunt-pill nge-hunt-pill--build",
                  title: "Help build a Hunt: suggest merges and cuts",
                  onClick: _cache[39] || (_cache[39] = $event => ($setup.buildState.helping = !$setup.buildState.helping))
                }, _hoisted_32))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: "nge-icon-btn nge-feedback-btn",
              title: "Submit an issue or feedback",
              onClick: _cache[40] || (_cache[40] = $event => ($setup.showFeedback = true))
            }, [
              _createCommentVNode(" A bug (Amy 2026-09-30), whose legs scurry on hover and click. "),
              _hoisted_33
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleToolbar, (icon) => {
              return (_openBlock(), _createElementBlock("button", {
                key: icon.id,
                "data-icon-id": icon.id,
                class: _normalizeClass(["nge-icon-btn", {
          'nge-icon-btn--badge': (icon.badge && icon.badge() > 0) || (icon.adminBadge && icon.adminBadge() > 0),
          'nge-icon-btn--mention': icon.id === 'chat' && $setup.chatMentionPending,
          'nge-icon-btn--active': $setup.isIconActive(icon.id),
          'nge-icon-btn--fresh': $setup.freshIcons.has(icon.id),
          'nge-icon-btn--off': icon.id === 'highlight' && !!$setup.highlightOff,
          'nge-icon-btn--idle': icon.id === 'undelete' && $setup.undeleteCount === 0,
          'nge-spraying': icon.id === 'highlight' && $setup.spraying,
          'nge-icon-btn--dragging': $setup.dragId === icon.id,
          'nge-icon-btn--drag-over': $setup.dragOverId === icon.id && $setup.dragId !== icon.id,
        }]),
                title: icon.id === 'highlight' && $setup.highlightOff ? $setup.highlightOff : icon.label + '. Drag to reorder.',
                "aria-disabled": icon.id === 'highlight' && $setup.highlightOff ? 'true' : undefined,
                draggable: "true",
                onDragstart: $event => ($setup.onIconDragStart($event, icon.id)),
                onDragend: $setup.onIconDragEnd,
                onDragover: $event => ($setup.onIconDragOver($event, icon.id)),
                onDragleave: $event => ($setup.onIconDragLeave(icon.id)),
                onDrop: $event => ($setup.onIconDrop($event, icon.id)),
                onClick: $event => (icon.action())
              }, [
                (icon.svg)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: icon.svg
                    }, null, 8 /* PROPS */, _hoisted_35))
                  : (icon.img)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: icon.img,
                        class: "nge-toolbar-icon-img"
                      }, null, 8 /* PROPS */, _hoisted_36))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(icon.emoji), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */)),
                (icon.badge && icon.badge() > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      class: _normalizeClass(["nge-toolbar-badge", { 'nge-toolbar-badge--chat': icon.id === 'chat', 'nge-toolbar-badge--beside': icon.adminBadge && icon.adminBadge() > 0 }])
                    }, _toDisplayString(icon.badge()), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true),
                (icon.adminBadge && icon.adminBadge() > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 4,
                      class: "nge-toolbar-badge nge-toolbar-badge--admin",
                      title: `${icon.adminBadge()} unread in Admin`
                    }, _toDisplayString(icon.adminBadge()), 9 /* TEXT, PROPS */, _hoisted_37))
                  : _createCommentVNode("v-if", true)
              ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_34))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Player view (Ames 2026-10-25): an admin seeing the game as players do.\n         Shown only while it is on; a click goes back to admin view. The dot\n         means admin or triage notifications are waiting. "),
      ($setup.backendStore.isAdmin && $setup.backendStore.playerView)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            type: "button",
            class: "nge-player-view-chip",
            title: $setup.backendStore.unreadStaffNotificationCount > 0 ? `Player view is on. ${$setup.backendStore.unreadStaffNotificationCount} admin notifications waiting. Click for admin view.` : 'Player view is on: admin things are hidden. Click for admin view.',
            onClick: _cache[41] || (_cache[41] = $event => ($setup.backendStore.setPlayerView(false)))
          }, [
            _createTextVNode("Player view"),
            ($setup.backendStore.unreadStaffNotificationCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_39))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_38))
        : _createCommentVNode("v-if", true),
      ($setup.login.sessions.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 5,
            class: "nge-icon-btn",
            onClick: _cache[42] || (_cache[42] = $event => {$setup.profileUserId = null; $setup.showProfile = true}),
            id: "profileBtn",
            title: "My Profile"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_40, _hoisted_43))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Phones: the leaderboard, where the layer side panel's sliders used to\n         sit (Ames 2026-10-05). The side panel is a desktop tool; on a phone\n         its button is hidden (mobile.css). "),
      ($setup.isMobileRef)
        ? (_openBlock(), _createElementBlock("button", {
            key: 6,
            class: "nge-icon-btn",
            id: "mobileLeaderboardBtn",
            title: "Leaderboard",
            "aria-label": "Leaderboard",
            onClick: _cache[43] || (_cache[43] = $event => ($setup.mobileOpenPanel('leaderboard')))
          }, [
            _createElementVNode("span", { innerHTML: $setup.LEADERBOARD_SVG }, null, 8 /* PROPS */, _hoisted_44)
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["DropdownList"], {
        "dropdown-group": "extension-bar-right",
        id: "hamburger",
        class: "rightMost",
        title: "Resources and tutorials"
      }, {
        buttonTitle: _withCtx(() => [
          _createElementVNode("span", { innerHTML: $setup.RESOURCES_MENU_SVG }, null, 8 /* PROPS */, _hoisted_45)
        ]),
        listItems: _withCtx(() => [
          _createCommentVNode(" Grouped (Amy 2026-09-25: \"more structured organization\"). Each\n             tutorial appears once: the old list had a \"Reset Tutorial N\" AND a\n             named entry for the same tutorial (both start it from step 0).\n             The Merge / Split / Find path video links were dropped: those\n             tools live in the top bar, and the Cut & Merge tutorial covers\n             them (the Find Path video stays in the Ask dock / Ctrl+K). "),
          _createElementVNode("li", {
            class: "nge-menu-heading",
            onClick: _cache[44] || (_cache[44] = _withModifiers(() => {}, ["stop"]))
          }, "Guided tour"),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[45] || (_cache[45] = $event => {$setup.tutorialStore.activeTutorial = 4; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
            }, _hoisted_48)
          ]),
          _createElementVNode("li", {
            class: "nge-menu-heading",
            onClick: _cache[46] || (_cache[46] = _withModifiers(() => {}, ["stop"]))
          }, "Tutorials"),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[47] || (_cache[47] = $event => {$setup.tutorialStore.activeTutorial = 1; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
            }, _hoisted_51)
          ]),
          _createElementVNode("li", null, [
            _createCommentVNode(" Merge and Cut run on practice cells one learner at a time: the\n               start goes through a gate (tutorial-3.ts) that offers a place in\n               line when the cells are held. "),
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[48] || (_cache[48] = $event => {$setup.startTutorial(3); $setup.closeHamburger()})
            }, _hoisted_54)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[49] || (_cache[49] = $event => {$setup.startTutorial(5); $setup.closeHamburger()})
            }, _hoisted_57)
          ]),
          _createCommentVNode(" Advanced Interface after Merge and Cut, then the Merger Sandbox\n             (Ames 2026-10-18: the ideal order). "),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[50] || (_cache[50] = $event => {$setup.tutorialStore.activeTutorial = 2; $setup.tutorialStore.setTutorialStep(0); $setup.closeHamburger()})
            }, _hoisted_60)
          ]),
          _createCommentVNode(" Retina access (Ames 2026-10-16): the Dataset Access form, in the\n             game. Number 5, straight after Advanced Interface (Ames\n             2026-10-23), the next step once the tutorials are done. "),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item nge-menu-access",
              onClick: _cache[51] || (_cache[51] = $event => ($setup.openAccessPanel()))
            }, [
              _hoisted_61,
              _createElementVNode("span", null, "Ask for Edit Access" + _toDisplayString($setup.accessLabel ? ` (${$setup.accessLabel})` : ''), 1 /* TEXT */)
            ])
          ]),
          _createCommentVNode(" The Proofreading Test (Ames, 2026-10-10): one cell with several\n             mistakes, scored by the server; a pass opens production. Shown\n             once a test is registered and enabled. "),
          ($setup.testStatus && $setup.testStatus.test)
            ? (_openBlock(), _createElementBlock("li", _hoisted_62, [
                _createElementVNode("div", {
                  class: "logoutButton button nge-menu-item",
                  onClick: _cache[52] || (_cache[52] = $event => {$setup.startProofreadingTest(); $setup.closeHamburger()})
                }, [
                  _createElementVNode("span", _hoisted_63, _toDisplayString($setup.testStatus.passed ? '✓' : '6'), 1 /* TEXT */),
                  _createElementVNode("span", null, "Proofreading Test (DO NOT TAKE, WIP)" + _toDisplayString($setup.testStatus.passed ? ' (passed)' : $setup.testStatus.queue?.called_until ? ' (your turn)' : $setup.testStatus.queue?.position ? ` (in line, ${$setup.testStatus.queue.position})` : ($setup.testStatus.free === false && !$setup.testStatus.mine) ? ' (in use)' : ''), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Standalone cut exercises (Ames, 2026-10-06): each opens on its\n             merged view and is done when its two points are on different\n             segments. A tick marks the ones this browser has finished. "),
          _createElementVNode("li", {
            class: "nge-menu-heading",
            onClick: _cache[53] || (_cache[53] = _withModifiers(() => {}, ["stop"]))
          }, "Merger Sandbox"),
          _createCommentVNode(" One entry: a merger is assigned, the next free one this player\n             has not cut yet (Ames, 2026-10-08). The count is theirs. "),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[54] || (_cache[54] = $event => {$setup.startNextSandbox(); $setup.closeHamburger()})
            }, [
              _createElementVNode("span", _hoisted_64, _toDisplayString($setup.sandboxCut >= $setup.SANDBOX_CELLS.length ? '✓' : $setup.sandboxCut), 1 /* TEXT */),
              _createElementVNode("span", null, "Cut the mergers (" + _toDisplayString($setup.sandboxCut) + " of " + _toDisplayString($setup.SANDBOX_CELLS.length) + ")", 1 /* TEXT */)
            ])
          ]),
          _createCommentVNode(" Cells that stop too soon: merge the missing pieces back on\n             (Ames, 2026-10-24). "),
          _createElementVNode("li", {
            class: "nge-menu-heading",
            onClick: _cache[55] || (_cache[55] = _withModifiers(() => {}, ["stop"]))
          }, "Extension Sandbox"),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[56] || (_cache[56] = $event => {$setup.startNextExtension(); $setup.closeHamburger()})
            }, [
              _createElementVNode("span", _hoisted_65, _toDisplayString($setup.extensionFinished >= $setup.EXTENSION_CELLS.length ? '✓' : $setup.extensionFinished), 1 /* TEXT */),
              _createElementVNode("span", null, "Find the missing pieces (" + _toDisplayString($setup.extensionFinished) + " of " + _toDisplayString($setup.EXTENSION_CELLS.length) + ")", 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("li", {
            class: "nge-menu-heading",
            onClick: _cache[57] || (_cache[57] = _withModifiers(() => {}, ["stop"]))
          }, "Just for fun"),
          ($setup.ARCADE_ENABLED)
            ? (_openBlock(), _createElementBlock("li", _hoisted_66, [
                _createElementVNode("div", {
                  class: "logoutButton button nge-menu-item",
                  onClick: _cache[58] || (_cache[58] = $event => {$setup.showArcade = true; $setup.closeHamburger()})
                }, _hoisted_69)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[59] || (_cache[59] = $event => {$setup.showPhotoMode = true; $setup.closeHamburger()})
            }, _hoisted_72)
          ]),
          _createElementVNode("li", {
            class: "nge-menu-heading",
            onClick: _cache[60] || (_cache[60] = _withModifiers(() => {}, ["stop"]))
          }, "Learn more"),
          _createCommentVNode(" The Proofreading Guide link was taken out (Ames 2026-10-16): the old\n             guide no longer matches Pyr. "),
          _createCommentVNode(" Laid out like the other rows, so it lines up on the left (Ames 2026-10-24). "),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "logoutButton button nge-menu-item",
              target: "_blank",
              rel: "noopener",
              href: "https://forum.eyewire.org",
              onClick: _cache[61] || (_cache[61] = $event => ($setup.closeHamburger()))
            }, _hoisted_75)
          ]),
          _createCommentVNode(" The same list of every key that ? opens (util/key_list.ts). "),
          _createElementVNode("li", null, [
            _createElementVNode("div", {
              class: "logoutButton button nge-menu-item",
              onClick: _cache[62] || (_cache[62] = $event => {$setup.openKeyList(); $setup.closeHamburger()})
            }, _hoisted_78)
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Far-right slot: mergeTopBars() relocates NG's ? (help) and the\n         layer side panel toggle here, toggle last so it hugs the panel it\n         opens (Amy 2026-08-17). "),
      _hoisted_79
    ], 32 /* HYDRATE_EVENTS */),
    _createCommentVNode(" ── Mobile only: welcome sheet + bottom nav (util/mobile.ts) ───────── "),
    _createCommentVNode(" logged-in gates the Guide's link mode on VALID sessions only: a stale\n       token in localStorage must not hide the Log in button (Amy: the\n       landing pop-up needs login until you are actually in). "),
    ($setup.isMobileRef)
      ? (_openBlock(), _createBlock($setup["MobileWelcome"], {
          key: 22,
          show: $setup.showMobileWelcome,
          "logged-in": $setup.validLogins.length > 0,
          "login-checked": $setup.login.checked,
          "user-name": $setup.validLogins[0]?.name,
          onHide: $setup.exploreWithoutLogin,
          onLogin: $setup.mobileWelcomeLogin,
          onTour: $setup.startMobileTour,
          onOpen: $setup.mobileOpenPanel
        }, null, 8 /* PROPS */, ["show", "logged-in", "login-checked", "user-name"]))
      : _createCommentVNode("v-if", true),
    ($setup.isMobileRef)
      ? (_openBlock(), _createBlock($setup["MobileTour"], {
          key: 23,
          show: $setup.showMobileTour,
          "logged-in": $setup.validLogins.length > 0,
          onFinish: _cache[63] || (_cache[63] = $event => ($setup.showMobileTour = false))
        }, null, 8 /* PROPS */, ["show", "logged-in"]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.isMobileRef)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_80, [
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showCellLibrary }),
              "data-mnav": "cells",
              onClick: _cache[64] || (_cache[64] = $event => ($setup.mobileNavTap('cells')))
            }, [
              _createElementVNode("span", _hoisted_81, [
                _createElementVNode("img", {
                  src: $setup.neuronIcon,
                  class: "nge-mnav-neuron",
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_82)
              ]),
              _hoisted_83
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showChat }),
              "data-mnav": "chat",
              onClick: _cache[65] || (_cache[65] = $event => ($setup.mobileNavTap('chat')))
            }, [
              _hoisted_84,
              _hoisted_85,
              ($setup.chatStore.unreadCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString($setup.chatStore.unreadCount), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showTagMode }),
              "data-mnav": "tags",
              onClick: _cache[66] || (_cache[66] = $event => ($setup.showTagMode = !$setup.showTagMode))
            }, _hoisted_89, 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showNotifications }),
              "data-mnav": "alerts",
              onClick: _cache[67] || (_cache[67] = $event => ($setup.showNotifications = !$setup.showNotifications))
            }, [
              _hoisted_90,
              _hoisted_91,
              ($setup.mobileNotifCount > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString($setup.mobileNotifCount), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass({ 'nge-mnav--active': $setup.showMobileWelcome }),
              "data-mnav": "guide",
              onClick: _cache[68] || (_cache[68] = $event => ($setup.showMobileWelcome = true))
            }, _hoisted_95, 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true)
    ])),
    _createCommentVNode(" \"Now entering <dataset>\" after a dataset switch (survives the reload). "),
    _createVNode($setup["DatasetTransition"]),
    _createVNode($setup["SegmentMarksPrompt"])
  ], 64 /* STABLE_FRAGMENT */))
}